import { postMessageWithPromise } from '../../../base/browser/postMessage.js';

export function createPopoutToken(): string {
    return Array.from(crypto.getRandomValues(new Uint8Array(16)), byte => byte.toString(16).padStart(2, '0')).join('');
}

/** Finish blank navigation before adopting UI, then restore through the worker. */
export async function restoreExtensionPopout(popup: Window, token: string, restorePreviousState: boolean) {
    if (popup.document.readyState !== 'complete') await new Promise<void>((resolve, reject) => {
        const loaded = () => { clearTimeout(timeout); resolve(); };
        const timeout = setTimeout(() => {
            popup.removeEventListener('load', loaded);
            reject(new Error('The inspector popup did not finish opening'));
        }, 10_000);
        popup.addEventListener('load', loaded, { once: true });
    });
    const result = await postMessageWithPromise({
        type: 'needle:popout:restore', token, restorePreviousState,
    }, undefined, { timeout: 10_000 });
    if (!result.success) throw Object.assign(new Error(result.error || 'Chrome could not restore the inspector popup'), { name: result.errorName || 'InspectorPopoutError' });
}
